"use client";

import { createIcon } from "@chakra-ui/react";

const PlusSvgIcon = createIcon({
  displayName: "PlusSvgIcon",
  viewBox: "0 0 16 16",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M7.99831 13.9301L7.9972 2.06738M2.06641 7.99819L13.9291 7.9993" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel"/>
  ),
});

export default PlusSvgIcon;
